import {
  createSettingsParam,
  createSettingsParams,
  SettingsParamType,
} from '@wix/tpa-settings';

import { MEMBER_NAME_HTML_TAG } from '../../constants/settings';

export type ISettingsParams = {
  showCoverPhoto: SettingsParamType.Boolean;
  showCoverPhotoDesktop: SettingsParamType.Boolean;
  showFollowButton: SettingsParamType.Boolean;
  showRoleLabel: SettingsParamType.Boolean;
  followButtonText: SettingsParamType.String;
  followingButtonText: SettingsParamType.String;
  messageButtonText: SettingsParamType.String;
  followingCountersText: SettingsParamType.String;
  followersCountersText: SettingsParamType.String;
  memberNameResponsiveHtmlTag: SettingsParamType.String;
  memberNameNonResponsiveHtmlTag: SettingsParamType.String;
  memberNameMobileHtmlTag: SettingsParamType.String;
};

const showCoverPhoto = createSettingsParam('showCoverPhoto', {
  type: SettingsParamType.Boolean,
  getDefaultValue: () => true,
});

export default createSettingsParams<ISettingsParams>({
  showCoverPhoto,
  showCoverPhotoDesktop: {
    type: SettingsParamType.Boolean,
    key: 'pw-show-cover-photo-desktop',
    dangerousKeyTransformationOverride: () => 'pw-show-cover-photo-desktop',
    getDefaultValue: ({ getSettingParamValue }) => {
      const showCoverPhotoFallback = getSettingParamValue(showCoverPhoto);
      return showCoverPhotoFallback === undefined
        ? true
        : showCoverPhotoFallback;
    },
  },
  showFollowButton: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showRoleLabel: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  followButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('profile-widget.follow'),
  },
  followingButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('profile-widget.unfollow'),
  },
  messageButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('profile-widget.message'),
  },
  followingCountersText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('profile-widget.following'),
  },
  followersCountersText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }) => t('profile-widget.followers'),
  },
  memberNameResponsiveHtmlTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => MEMBER_NAME_HTML_TAG.RESPONSIVE,
  },
  memberNameNonResponsiveHtmlTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => MEMBER_NAME_HTML_TAG.NON_RESPONSIVE,
  },
  memberNameMobileHtmlTag: {
    type: SettingsParamType.String,
    getDefaultValue: () => MEMBER_NAME_HTML_TAG.MOBILE,
  },
});
